import { getAnalytics } from "firebase/analytics";
import firebase from "firebase/compat/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { connectDatabaseEmulator, getDatabase } from "firebase/database";

// TODO: Legacy version 8 firestore support.
// To remove and refactor code to work with version 9
import "firebase/compat/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGESENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
};
const firebaseApp = firebase.initializeApp(firebaseConfig);

// TODO: Support both v8 and v9 while upgrade of SDK is going on.
const dbv9 = getFirestore(firebaseApp);
const dbv8 = firebase.firestore(firebaseApp);

const DEFAULT_REGION = "us-east1";

const firebaseAuth = getAuth(firebaseApp);
const storageRef = getStorage(firebaseApp);
const fxs = getFunctions(firebaseApp, DEFAULT_REGION);
const rtdb = getDatabase(firebaseApp, firebaseConfig.databaseURL);

if (window.location.hostname === "localhost" || process.env.CI) {
    console.log("---- Using firestore emulator ----");
    connectFirestoreEmulator(dbv8, "localhost", 8082);
    connectFirestoreEmulator(dbv9, "localhost", 8082);
    connectAuthEmulator(firebaseAuth, "http://localhost:9099");
    connectFunctionsEmulator(fxs, "localhost", 5001);
    connectStorageEmulator(storageRef, "localhost", 9199);
    connectDatabaseEmulator(rtdb, "localhost", 9001);
} else {
    getAnalytics(firebaseApp);
}

export { dbv9, fxs, firebaseAuth, rtdb };

export default dbv8;
